import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiWifi, FiTv, FiThermometer, FiDroplet, FiCoffee, FiPhone } = FiIcons;

function Rooms() {
  const amenities = [
    { icon: FiThermometer, name: "Air Conditioning" },
    { icon: FiDroplet, name: "Hot Water" },
    { icon: FiWifi, name: "Free WiFi" },
    { icon: FiTv, name: "Cable TV" },
    { icon: FiCoffee, name: "Tea/Coffee" },
    { icon: FiPhone, name: "Room Service" }
  ];

  return (
    <section id="rooms" className="section-padding">
      <div className="container">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-gradient">Superior</span> Accommodation
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Experience comfort and elegance in our SLTDA-certified Superior Bungalow rooms, 
            designed for the discerning traveler seeking quality and tranquility.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            className="space-y-8"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="glass-card p-8">
              <h3 className="text-3xl font-bold mb-6">Superior Bungalow Rooms</h3>
              <p className="text-white/90 mb-6">
                Our 4 carefully appointed rooms offer a perfect blend of modern comfort and traditional charm. 
                Each room is designed to provide a peaceful retreat after exploring the cultural treasures of Sabaragamuwa.
              </p>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 glass-card rounded-lg">
                  <span className="font-semibold">Room Type</span>
                  <span className="text-blue-300">Superior Bungalow</span>
                </div>
                <div className="flex justify-between items-center p-4 glass-card rounded-lg">
                  <span className="font-semibold">Capacity</span>
                  <span className="text-blue-300">2-3 Guests per room</span>
                </div>
                <div className="flex justify-between items-center p-4 glass-card rounded-lg">
                  <span className="font-semibold">Total Rooms</span>
                  <span className="text-blue-300">4 Rooms Available</span>
                </div>
              </div>

              <div className="mt-8">
                <a href="tel:076-8727112" className="btn-glass w-full justify-center">
                  <SafeIcon icon={FiPhone} />
                  Book Your Stay - Call 076-8727112
                </a>
              </div>
            </div>

            <motion.div
              className="glass-card p-6"
              whileHover={{ scale: 1.02 }}
            >
              <h4 className="text-xl font-semibold mb-4">Day Use Available</h4>
              <p className="text-white/80">
                Perfect for travelers needing a rest during long journeys. 
                Ideal for pilgrims heading to Kataragama or families exploring the region.
              </p>
            </motion.div>
          </motion.div>

          <motion.div
            className="space-y-6"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="glass-card p-8">
              <h3 className="text-2xl font-bold mb-6">Room Amenities</h3>
              <div className="grid grid-cols-2 gap-4">
                {amenities.map((amenity, index) => (
                  <motion.div
                    key={index}
                    className="flex items-center gap-3 p-3 glass-card rounded-lg"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.2 }}
                  >
                    <SafeIcon icon={amenity.icon} className="text-blue-300" />
                    <span className="text-sm font-medium">{amenity.name}</span>
                  </motion.div>
                ))}
              </div>
            </div>

            <div className="glass-card p-8">
              <h4 className="text-xl font-semibold mb-4">SLTDA Certification</h4>
              <p className="text-white/80 mb-4">
                Our Superior Bungalow classification guarantees:
              </p>
              <ul className="space-y-2 text-white/80">
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></span>
                  Quality assurance and safety standards
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></span>
                  Regular inspections and maintenance
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></span>
                  Professional hospitality standards
                </li>
              </ul>
              <div className="mt-4 text-sm text-blue-300">
                Registration: SLTDA/SQA/BUN/01295 | License: BUN/2025/0075
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Rooms;